import {compose, createStore} from 'redux';
import rootReducer from '../Redux/Reducers/combineReducers'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
  }
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const initialState = {}

const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers()
)

export default store;